<template>
    <div class="careers-internship">
      <div class="careers-internship-content">
        <p class="indent">Alcomet offre notevoli opportunità di formazione e carriera per giovani professionisti attraverso una varietà di programmi di formazione per studenti e borse di studio individuali..</p>
        <ul>
            <li class="strong underline">Programmi di formazione aziendale</li>
        </ul>
        <p class="strong">Durata:</p>
        <ul>
            <li class="underline">1 mese</li>
        </ul>
        <p class="strong">Condizioni dei programmi di formazione aziendale:</p>
        <ul>
            <li>Il programma è rivolto a studenti universitari che abbiano superato il terzo anno di corso, a studenti di Master universitario o giovani specialisti laureatisi di recente.</li>
            <li>Come tirocinante presso la nostra azienda, riceverete benefit quali la possibilità di usufruire del pasto presso la nostra mensa e del trasporto da e per il luogo di lavoro.</li>
        </ul>
        <p class="strong">Ambiti dei tirocini:</p>
        <ul>
            <li>- Metallurgia</li>
            <li>- Ingegneria chimica</li>
            <li>- Tecnologia idraulica e pneumatica</li>
            <li>- Dotazione strumentale, macchine ed apparecchiature</li>
            <li>- Information technologies</li>
            <li>- Sistemi di gestione automatizzati</li>
            <li>- Gestione industriale</li>
        </ul>
        <p class="strong"> Come presentare domanda:</p>
        <p class="indent">In caso foste interessati a presentare richiesta di tirocinio aziendale, inviate il vostro CV con una lettera di presentazione [in inglese] che illustri i vostri interessi, le idee ed i programmi per il futuro, nonché indicazioni sul campo di vostro interesse per il tirocinio, al seguente indirizzo:</p>
        <p class="no-margin">E-mail: <a href="mailto:hr@alcomet.eu">hr@alcomet.eu</a></p>
        <p class="no-margin">2nd Industrial Zone</p>
        <p class="no-margin">9700 Shumen</p>
        <p class="no-margin">Alcomet AD</p>
      </div>
      <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.careers-internship-content {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.careers-internship-content > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.careers-internship-content > ul {
  list-style: disc;
  padding-left: 20px;
  width: 60%;
}
.careers-internship-content ul li {
  display: block;
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
}
.careers-internship-content .no-margin {
  margin: 0;
}
.careers-internship-content .underline {
  text-decoration: underline;
}
@media screen and (max-width: 1000px) {
  .careers-internship-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .careers-internship-content > ul {
    padding-left: 50px;
    padding-right: 30px;
    width: 100%;
  }
  .careers-internship-content ul li {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/careers/Internships.vue